<template>
    <div class="tab_bar">
        <div class="mdc-tab-bar view-tab-bar  bottom-shadow" role="tablist" id="examViewSubTab" ref="examViewTab">
            <div class="mdc-tab-scroller">
                <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll">
                    <div class="mdc-tab-scroller__scroll-content">
                        <button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="changeTabType('Information')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('1003')}}
                                    <!-- 시험지 정보 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator mdc-tab-indicator--active">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        <button class="mdc-tab" role="tab" tabindex="1" @click="changeTabType('Reward')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('1004')}}
                                    <!-- 리워드 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 시험 상세 탭바 정보
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.11
 */

// Components/Mixin/Extend/API 선언
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
    props: ['setTabFixed'],
    data() {
        return {
            examViewTab: null,
            tabType: 'Information',
        }
    },
    mounted() {
        console.log('viewTabMounted');
        
        this.examViewTab = new MDCTabBar(document.querySelector('#examViewSubTab'))
    },

    updated() {
        this.examViewTab = new MDCTabBar(document.querySelector('#examViewSubTab'))

        if (this.tabType === 'Information') {
            this.examViewTab.activateTab(0)
        }else if (this.tabType === 'Reward') {
            this.examViewTab.activateTab(1)
        }else {
            this.examViewTab.activateTab(0)
        }
    },

    computed: {
       isTabType() {
           return this.tabType
       }
    },

    methods: {
        changeTabType(type) {
            this.tabType = type
            this.$emit('setViewTab', type)
        }
        
    }

}
</script>

<style scoped>

</style>